// import { alert, force, confirm, input, select, date, setOptions, hideAlerts } from 'notie'
import notie from 'notie'
import { forEach } from 'lodash'

forEach(notyfConfirm, function(value) {
    notie.alert({
        text: value,
        type: 'success'
    })
})